// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import ConditionsList from '../../components/Rules/ConditionsList'
import ActionList from '../../components/Rules/ActionList'
import FormValidationError from "../../components/InitialConfig/FormValidationError"

var dashboardCommonJS = require("../../js/dashboardCommon.js");
var rulesCommonJS = require("../../js/rulesCommon.js")
var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

// DASHBOARD
const RuleForm = (params) => {
  
  const [conditionsUpdateTimestamp, setConditionsUpdateTimestamp] = useState(0)
  const [actionsUpdateTimestamp, setActionsUpdateTimestamp] = useState(0)
  

  useEffect(() => {   
    console.log("Refresco formulario regla")

    //Si cargo una regla existente
    if(params.rule.RULE_ID !== ""){ 
      setearValoresRegla()  
      visualizarResumenGeneral()      
    }
    else{      

      var numeroReglas = parseInt(document.getElementById("spanNumeroReglasManuales").innerHTML.replaceAll("( ", "").replaceAll(" )", ""))

      if(numeroReglas === 0){ mostrarEjemploRegla() }      
      else{ document.getElementById("divEjemploRegla").className = document.getElementById("divEjemploRegla").className.replaceAll(" hidden", "") + " hidden" }

      abrirTodosLosBloques()      
      if( (params.rule.Rule.conditions.length === 1) && (params.rule.Rule.actions.length === 1) ){
        inicializarFormulario()
      }      
    }
    
  }, [params,conditionsUpdateTimestamp,actionsUpdateTimestamp]);

  function setearValoresRegla(){

    document.getElementById("nombreRegla").value = params.rule.Rule.name

    if(params.rule.Rule.enabled === "true"){
      document.getElementById("estadoRegla").checked = true
    }
    else{
      document.getElementById("estadoRegla").checked = false
    }

  }

  function añadirCondicion(){

    var objRuleTemp = params.rule

    objRuleTemp = generarJSONGuardado()

    var nuevoIdCondicion = 0

    for(var x=0; x < (objRuleTemp.Rule.conditions.length); x++){
      if(parseInt(objRuleTemp.Rule.conditions[x].conditionId) > nuevoIdCondicion){
        nuevoIdCondicion = parseInt(objRuleTemp.Rule.conditions[x].conditionId)
      }
    }

    nuevoIdCondicion = nuevoIdCondicion + 1

    var nuevaCondicionTemp = {
      "conditionalOperator":"",
      "comparator":"",
      "conditionId":(nuevoIdCondicion).toString(),
      "atribute":"",
      "atributeValue":""
    }

    objRuleTemp.Rule.conditions.push(nuevaCondicionTemp)

    setConditionsUpdateTimestamp(new Date().getTime())

  }

  function eliminarCondicion(idCondicion){
    
    var condiciones = params.rule.Rule.conditions
    var posicionElementoABorrar = ""

    for(var x=0; x < condiciones.length;x++){
      if(idCondicion === condiciones[x].conditionId){
        posicionElementoABorrar = x
      }
    }

    params.rule.Rule.conditions.splice( posicionElementoABorrar, 1 );        
    setConditionsUpdateTimestamp(new Date().getTime())    
  }

  function añadirAccion(){

    var objRuleTemp = params.rule

    objRuleTemp = generarJSONGuardado()

    var nuevoIdAccion = 0

    for(var x=0; x < (objRuleTemp.Rule.actions.length); x++){
      if(parseInt(objRuleTemp.Rule.actions[x].actionId) > nuevoIdAccion){
        nuevoIdAccion = parseInt(objRuleTemp.Rule.actions[x].actionId)
      }
    }

    nuevoIdAccion = nuevoIdAccion + 1

    var nuevaAccionTemp = {
      "actionId":(nuevoIdAccion).toString(),
      "action":""
    }

    objRuleTemp.Rule.actions.push(nuevaAccionTemp)

    setActionsUpdateTimestamp(new Date().getTime())

  }

  function eliminarAccion(idAccion){

    var acciones = params.rule.Rule.actions
    var posicionElementoABorrar = ""

    for(var x=0; x < acciones.length;x++){
      if(idAccion === acciones[x].actionId){
        posicionElementoABorrar = x
      }
    }

    params.rule.Rule.actions.splice( posicionElementoABorrar, 1 );    
    setActionsUpdateTimestamp(new Date().getTime())    
  }

  function obtenerTextoComparador(comparador){
    
    var texto = ""

    if(comparador === "="){ texto = "igual a"}
    else if(comparador === ">="){ texto = "mayor o igual que"}
    else if(comparador === "<="){ texto = "menor o igual que"}
    else if(comparador === ">"){ texto = "mayor que"}
    else if(comparador === "<"){ texto = "menor que"}
    else if(comparador === "!="){ texto = "distinto de"}

    return texto
  }

  function obtenerTextoComparadorCondicional(comparadorCondicional){
    
    var texto = ""

    if(comparadorCondicional === "&"){ texto = "Y"}
    else if(comparadorCondicional === "|"){ texto = "O"}
    
    return texto
  }

  function mostrarOcultarBloqueResumen(idBloque){

    try{
      var procesarPeticion = true

      //Proceso comportamiento sectionInfoBasicaRegla
      if ((idBloque === "sectionInfoBasicaRegla") && (document.getElementById("nombreRegla").value === "")){
        document.getElementById("nombreRegla").className = "error"    
        document.getElementById("nombreRegla").placeholder = "Introduce un nombre"    
        procesarPeticion = false
      }
      else{
        document.getElementById("nombreRegla").className = ""      
        document.getElementById("resumenInfoGeneralRegla").innerHTML = document.getElementById("nombreRegla").value

        if(document.getElementById("estadoRegla").checked === true){
          document.getElementById("figureEstadoActivacionResumenRegla").className = document.getElementById("figureEstadoActivacionResumenRegla").className.replace(" cyan", " green")        
          document.getElementById("spanEstadoActivacionResumenRegla").innerHTML = "toggle_on"
        }
        else{
          document.getElementById("figureEstadoActivacionResumenRegla").className = document.getElementById("figureEstadoActivacionResumenRegla").className.replace(" green", " cyan")        
          document.getElementById("spanEstadoActivacionResumenRegla").innerHTML = "toggle_off"
        }
      }

      //Proceso comportamiento detalleCondicionX

      if(idBloque.includes("detalleCondicion")){
      
        var idCondicion = idBloque.split("detalleCondicion")[1]

        if(document.getElementById("valorAtributo"+idCondicion) !== null){

          if (document.getElementById("valorAtributo"+idCondicion).value === ""){
            document.getElementById("valorAtributo"+idCondicion).className = "error"    
            document.getElementById("valorAtributo"+idCondicion).placeholder = "Introduce un valor"    
            procesarPeticion = false
          }
          else{
            document.getElementById("valorAtributo"+idCondicion).className = ""      
            
            var textoOpCondicional = ""

            if(idCondicion === "1"){ textoOpCondicional = "Si " }
            else{
              if (document.getElementById("selectOperadorCondicional"+idCondicion+"&").checked === true){ textoOpCondicional = obtenerTextoComparadorCondicional("&") }
              else { textoOpCondicional = obtenerTextoComparadorCondicional("|") }
            }

            var textoComparador = obtenerTextoComparador(document.getElementById("selectListaComparadores"+idCondicion).value)
            var textoAtributo = ""
            if(document.getElementById("selectListaAtributos"+idCondicion).options[document.getElementById("selectListaAtributos"+idCondicion).selectedIndex] !== undefined){
              textoAtributo = document.getElementById("selectListaAtributos"+idCondicion).options[document.getElementById("selectListaAtributos"+idCondicion).selectedIndex].innerHTML          
            }
            else{
              textoAtributo = "ATRIBUTO NO DISPONIBLE"
            }
            
            var textoValorAtributo = ""

            if(document.getElementById("selectListaAtributos"+idCondicion).value.includes("|Estado")){            

              var tipoDispositivo = dashboardCommonJS.obtenerTipoDispositivo(document.getElementById("selectListaAtributos"+idCondicion).value.split("|")[1], document.getElementById("selectCategoriaAtributos"+idCondicion).value)

              var estadoDispositivoTemp = document.getElementById("valorAtributo"+idCondicion).value

              if(tipoDispositivo === "PERSIANA"){
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Subida" }
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Bajada" }
                else{ estadoDispositivoTemp = "Offline" }
              }

              else if( (tipoDispositivo === "SENSOR_TEMPERATURA") || (tipoDispositivo === "SENSOR_HUMEDAD") ){
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Online" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Online" }
                else{ estadoDispositivoTemp = "Offline" }
              
              }

              else if(tipoDispositivo === "SENSOR_PUERTA_VENTANA"){
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Abierto" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Cerrado" }
                else{ estadoDispositivoTemp = "Offline" }
              
              }
              
              else if(tipoDispositivo === "TV"){
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Online" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Online" }
                else{ estadoDispositivoTemp = "Offline" }

              }

              else if(tipoDispositivo === "AIRE_ACONDICIONADO"){
                  
                  if(estadoDispositivoTemp === "CALOR"){ estadoDispositivoTemp = "CALOR" }              
                  else if(estadoDispositivoTemp === "FRIO"){ estadoDispositivoTemp = "FRIO" }
                  else{ estadoDispositivoTemp = "off" }

              }

              else if(tipoDispositivo.includes("LAVADORA")){
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "LavadoraLista" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "LavadoraRemotoDesactivado" }
                else if(estadoDispositivoTemp === "running"){ estadoDispositivoTemp = "LavadoraLavando" }
                else{ estadoDispositivoTemp = "Offline" }
                
              }              

              textoValorAtributo = dashboardCommonJS.obtenerLiteralEstadoAccion(estadoDispositivoTemp).toLowerCase()   

            }
            else{

              if(document.getElementById("selectListaAtributos"+idCondicion).value === "WeekDay"){
                textoValorAtributo = dashboardCommonJS.obtenerNombreDiaDeLaSemana(document.getElementById("valorAtributo"+idCondicion).value).toLowerCase()
              }
              else if(document.getElementById("selectListaAtributos"+idCondicion).value === "Month"){
                textoValorAtributo = dashboardCommonJS.obtenerNombreMes(document.getElementById("valorAtributo"+idCondicion).value).toLowerCase()
              }              
              else if(document.getElementById("selectListaAtributos"+idCondicion).value === "ForceSurplusSellToGrid"){                
                textoValorAtributo = dashboardCommonJS.obtenerLiteralEstadoAccion(document.getElementById("valorAtributo"+idCondicion).value).toLowerCase()
              }
              else if(document.getElementById("selectListaAtributos"+idCondicion).value === "ForceBatteryChargeFromGrid"){                
                textoValorAtributo = dashboardCommonJS.obtenerLiteralEstadoAccion(document.getElementById("valorAtributo"+idCondicion).value).toLowerCase()
              }
              else{                
                textoValorAtributo = document.getElementById("valorAtributo"+idCondicion).value
              }
              
            }
              
            var unidadValorAtributo = document.getElementById("fieldsetValorAtributo"+idCondicion).getAttribute("data-label")

            //Oculto en ciertos casos (Estados principalmente) las unidades ya que no aplican

            var atributosSinUnidad = ["ChargeLatchStatus","ChargeStatus","FVStatus","BatteryStatus","ForceSurplusSellToGrid","ForceBatteryChargeFromGrid"]

            if(atributosSinUnidad.includes(document.getElementById("selectListaAtributos"+idCondicion).value)){
              unidadValorAtributo = ""
            }

            // Controlo visualización de casuísticas especiales

            if( (document.getElementById("selectListaAtributos"+idCondicion).value === "ItsDay") || (document.getElementById("selectListaAtributos"+idCondicion).value === "ItsNight") ){
              document.getElementById("resumenReglaCondicion"+idCondicion).innerHTML = textoOpCondicional + " " + textoAtributo.toLowerCase()
            }
            else if( (document.getElementById("selectListaAtributos"+idCondicion).value === "BestBuyPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "BestSellPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "WorstBuyPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "WorstSellPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "DailyAverageBuyPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "DailyAverageSellPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "DailyAverageSellPriceDaylight")){
              document.getElementById("resumenReglaCondicion"+idCondicion).innerHTML = textoOpCondicional + " " + textoAtributo.toLowerCase()
            }
            else if( (document.getElementById("selectListaAtributos"+idCondicion).value === "SunriseOffset") || (document.getElementById("selectListaAtributos"+idCondicion).value === "SunsetOffset") ){
              document.getElementById("resumenReglaCondicion"+idCondicion).innerHTML = textoAtributo[0].toUpperCase() + textoAtributo.slice(1).toLowerCase() + " y tras " + parseInt(textoValorAtributo).toString() + " " + unidadValorAtributo.toLowerCase()              
            }
            else if( (document.getElementById("selectListaAtributos"+idCondicion).value === "EnergyBuyPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "MarketAverageBuyPrice") 
              || (document.getElementById("selectListaAtributos"+idCondicion).value === "EnergySellPrice") || (document.getElementById("selectListaAtributos"+idCondicion).value === "DailyEnergySellPrice") 
            ){

              if(document.getElementById("selectListaComparadores"+idCondicion).value.includes("···")){ //Ejemplo: <=···DailyAverageBuyPrice

                document.getElementById("resumenReglaCondicion"+idCondicion).innerHTML = textoAtributo[0].toUpperCase() + textoAtributo.slice(1).toLowerCase() + " " + initialConfigCommonJS.obtenerLiteralAtributo(document.getElementById("selectListaComparadores"+idCondicion).value).toLowerCase()              

              }
              else{ // Comparador normal con valor
                document.getElementById("resumenReglaCondicion"+idCondicion).innerHTML = textoOpCondicional + " " + textoAtributo.toLowerCase() + " es " + textoComparador + " " + textoValorAtributo + " " + unidadValorAtributo
              }              

            }
            else{
              document.getElementById("resumenReglaCondicion"+idCondicion).innerHTML = textoOpCondicional + " " + textoAtributo.toLowerCase() + " es " + textoComparador + " " + textoValorAtributo + " " + unidadValorAtributo
            }            

            if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "GeneralData"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m grey"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "analytics"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "InstallationData.GeneralInfo"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m green"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = dashboardCommonJS.obtenerIconoInstalacion(localStorage.getItem("installationName").split("*")[0])
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "MeteoData"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m orange"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "filter_drama"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "FVData"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m pink"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "solar_power"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "BatteriesData"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m pink"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "battery_std"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "GeneratorData"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m pink"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "dynamic_form"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "CarsData"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m pink"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "directions_car"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "Devices"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m green"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "devices_other"
            }
            else if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "Schedule"){
              document.getElementById("figureIconoCondicionRegla"+idCondicion).className = "avatar size-m cyan"
              document.getElementById("spanIconoCondicionRegla"+idCondicion).innerHTML = "date_range"
            }
          }
        }

      }

      //Proceso comportamiento sectionAccionesRegla
      if(idBloque.includes("detalleAccion")){
        
        var idAccion = idBloque.split("detalleAccion")[1]

        if((!document.getElementById("fieldsetValorAccion"+idAccion).className.includes(" hidden")) && (document.getElementById("valorAccion"+idAccion).value === "") ){

          document.getElementById("valorAccion"+idAccion).className = "error"    
          document.getElementById("valorAccion"+idAccion).placeholder = "Introduce un valor"    
          procesarPeticion = false
        }
        else{

          document.getElementById("valorAccion"+idAccion).className = ""      
          
          document.getElementById("resumenAccionesRegla"+idAccion).innerHTML = document.getElementById("selectAcciones"+idAccion).options[document.getElementById("selectAcciones"+idAccion).selectedIndex].innerHTML
                  
          if(!document.getElementById("fieldsetValorAccion"+idAccion).className.includes(" hidden")){
            document.getElementById("resumenAccionesRegla"+idAccion).innerHTML += ': "'+document.getElementById("valorAccion"+idAccion).value+'"'
          }

          if(document.getElementById("selectBloquesAcciones"+idAccion).value === "GrupoElectrogeno"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m pink"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "dynamic_form"
          }
          else if(document.getElementById("selectBloquesAcciones"+idAccion).value === "Paneles"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m pink"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "solar_power"
          }
          else if(document.getElementById("selectBloquesAcciones"+idAccion).value === "Baterias"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m pink"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "battery_std"
          }
          else if(document.getElementById("selectBloquesAcciones"+idAccion).value === "Coche"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m pink"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "directions_car"
          }
          else if(document.getElementById("selectBloquesAcciones"+idAccion).value === "Dispositivos"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m green"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "devices_other"
          }
          else if(document.getElementById("selectBloquesAcciones"+idAccion).value === "Mensajeria"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m cyan"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "mail"
          }
          else if(document.getElementById("selectBloquesAcciones"+idAccion).value === "RegistroActividad"){
            document.getElementById("figureIconoAccionRegla"+idAccion).className = "avatar size-m cyan"
            document.getElementById("spanIconoAccionRegla"+idAccion).innerHTML = "fact_check"
          }

          document.getElementById("mensajeInformativoAccion"+idAccion).className += " hidden"

        }

      }
      //Finalmente proceso la visibilidad del bloque
      if(procesarPeticion){

        if (document.getElementById(idBloque) !== null){

          if ( document.getElementById(idBloque).className.includes("expanded") ) {
            document.getElementById(idBloque).className = document.getElementById(idBloque).className.replace(" expanded","")
          }
          else{
              document.getElementById(idBloque).className += " expanded"
              if( (document.getElementById("selectBloquesAcciones"+idAccion) !== null) && (document.getElementById("selectBloquesAcciones"+idAccion).value === "RegistroActividad") ){
                document.getElementById("mensajeInformativoAccion"+idAccion).className = document.getElementById("mensajeInformativoAccion"+idAccion).className.replaceAll(" hidden","")
              }
                
          }
        }
      }
    }
    catch(error){console.log(error)}    

  }

  function abrirTodosLosBloques(){
    //Seteo a abierto todo
    if (!document.getElementById("sectionInfoBasicaRegla").className.includes("expanded")){
      document.getElementById("sectionInfoBasicaRegla").className += " expanded"
    }

    var condiciones = document.getElementById("Condiciones").querySelectorAll("section")

    for(var x=0; x < condiciones.length; x++){
      if ( (document.getElementById(condiciones[x].id) !== null) && (!document.getElementById(condiciones[x].id).className.includes("expanded")) ){
        document.getElementById(condiciones[x].id).className += " expanded"      
      }
    }

    var acciones = document.getElementById("Acciones").querySelectorAll("section")

    for(x=0; x < acciones.length; x++){        
      if (!document.getElementById(acciones[x].id).className.includes("expanded")){
        document.getElementById(acciones[x].id).className += " expanded"
      }
    }
    
  }

  function inicializarFormulario(){

    console.log("Inicializo formulario")

    //Inicializo datos básicos
    document.getElementById("nombreRegla").value = ""
    document.getElementById("estadoRegla").checked = true
    
    //Inicializo datos de condiciones
    for(var x=0; x < document.getElementById("Condiciones").querySelectorAll("section").length; x++){      
      document.getElementById("selectCategoriaAtributos"+(x+1)).selectedIndex = 0
      document.getElementById("selectListaAtributos"+(x+1)).selectedIndex = 0
      document.getElementById("selectListaComparadores"+(x+1)).selectedIndex = 0
      document.getElementById("valorAtributo"+(x+1)).value = ""
    }    

    //Inicializo datos de acciones
    for(x=0; x < document.getElementById("Acciones").querySelectorAll("section").length; x++){
      document.getElementById("selectBloquesAcciones"+(x+1)).selectedIndex = 0
      document.getElementById("selectAcciones"+(x+1)).selectedIndex = 0
      document.getElementById("valorAccion"+(x+1)).value = ""
    }   

  }

  function visualizarResumenGeneral(){

    abrirTodosLosBloques()
    
    // Y ahora proceso el cierre automático y la actualización de la visualización
    mostrarOcultarBloqueResumen("sectionInfoBasicaRegla")
    
    var condiciones = document.getElementById("Condiciones").querySelectorAll("section")

    for(var x=0; x < condiciones.length; x++){
      mostrarOcultarBloqueResumen(condiciones[x].id)   
    }    

    var acciones = document.getElementById("Acciones").querySelectorAll("section")

    for(x=0; x < acciones.length; x++){
      mostrarOcultarBloqueResumen(acciones[x].id)   
    }   
    
  }

  function validacionCamposCorrecta(){

    var numeroErroresValidacion = 0

    document.getElementById("nombreRegla").className = ""      
    
    //Reviso todos los datos básicos
    if(document.getElementById("nombreRegla").value === ""){
      numeroErroresValidacion++
      document.getElementById("nombreRegla").className = "error"
    }

    //Reviso todos los campos de condiciones
    var objCondiciones = document.getElementById("Condiciones").querySelectorAll("input[type='text']")

    for(var x=0; x < objCondiciones.length; x++){   

      document.getElementById(objCondiciones[x].id).className = ""

      if( document.getElementById(objCondiciones[x].id).value === ""){
        numeroErroresValidacion++
        document.getElementById(objCondiciones[x].id).className = "error"
      }      
      else{

        if( (!document.getElementById("fieldsetPrincipalValorAtributo"+objCondiciones[x].id.replaceAll("valorAtributo","")).className.includes(" hidden")) && (/^\d+$/.test(document.getElementById(objCondiciones[x].id).value.replaceAll(",","").replaceAll(".",""))) === false ){ //Si el valor del input es sólo numérico....
          numeroErroresValidacion++
          document.getElementById(objCondiciones[x].id).className = "error"
          document.getElementById("detalleCondicion"+objCondiciones[x].id.replaceAll("valorAtributo","")).className = document.getElementById("detalleCondicion"+objCondiciones[x].id.replaceAll("valorAtributo","")).className.replaceAll(" expanded","") + " expanded"
          initialConfigCommonJS.mostrarMensajeInformativo("El campo valor no puede tener letras ni espacios.","negative")
        }      
      }
    }

    //Reviso todos los campos de acciones

    var objAcciones = document.getElementById("Acciones").querySelectorAll("input[type='text']")

    var nombreFieldsetActual = ""

    for(x=0; x < objAcciones.length; x++){   

      nombreFieldsetActual = "fieldset"+objAcciones[x].id.charAt(0).toUpperCase() + objAcciones[x].id.slice(1)
      
      document.getElementById(objAcciones[x].id).className = ""

      if( (!document.getElementById(nombreFieldsetActual).className.includes(" hidden")) && (document.getElementById(objAcciones[x].id).value === "") ){
        numeroErroresValidacion++
        document.getElementById(objAcciones[x].id).className = "error"
      }      
    }

    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }

  function generarJSONGuardado(){

    var jsonGuardado = params.rule

    jsonGuardado.Rule.name = document.getElementById("nombreRegla").value

    if(document.getElementById("estadoRegla").checked === true){ jsonGuardado.Rule.enabled = "true" }
    else{ jsonGuardado.Rule.enabled = "false" }

    for(var x=0; x < jsonGuardado.Rule.conditions.length; x++){
      
      //Si es la primera condición el operador condicional debe ser vacio
      if(x !== 0){ 
        
        if(document.getElementById("selectOperadorCondicional"+(x+1)+"&") !== null){
          if(document.getElementById("selectOperadorCondicional"+(x+1)+"&").checked === true){ jsonGuardado.Rule.conditions[x].conditionalOperator = "&" }
          else{ jsonGuardado.Rule.conditions[x].conditionalOperator = "|" }
        }
      }
      else{ jsonGuardado.Rule.conditions[x].conditionalOperator = "" }

      jsonGuardado.Rule.conditions[x].atribute = document.getElementById("selectCategoriaAtributos"+jsonGuardado.Rule.conditions[x].conditionId).value+"|"+document.getElementById("selectListaAtributos"+jsonGuardado.Rule.conditions[x].conditionId).value

      document.getElementById("valorAtributo"+jsonGuardado.Rule.conditions[x].conditionId).value = document.getElementById("valorAtributo"+jsonGuardado.Rule.conditions[x].conditionId).value.replaceAll(",",".")

      if(jsonGuardado.Rule.conditions[x].atribute.split("|")[0] === "MeteoData"){
        if(document.getElementById("valorAtributo"+jsonGuardado.Rule.conditions[x].conditionId).value.includes(".")){
          jsonGuardado.Rule.conditions[x].atributeValue = document.getElementById("valorAtributo"+jsonGuardado.Rule.conditions[x].conditionId).value
        }

        else{
          jsonGuardado.Rule.conditions[x].atributeValue = document.getElementById("valorAtributo"+jsonGuardado.Rule.conditions[x].conditionId).value+".0"
        }
        
      }
      else{
        jsonGuardado.Rule.conditions[x].atributeValue = document.getElementById("valorAtributo"+jsonGuardado.Rule.conditions[x].conditionId).value
      }

      //Filtro determinados caracteres que podrían ser problemáticos
      jsonGuardado.Rule.conditions[x].atributeValue = jsonGuardado.Rule.conditions[x].atributeValue.replaceAll("%", "")      
      jsonGuardado.Rule.conditions[x].comparator = document.getElementById("selectListaComparadores"+jsonGuardado.Rule.conditions[x].conditionId).value

    }
    
    var accionTemp = ""
    var emailTemp = ""

    for(var y=0; y < jsonGuardado.Rule.actions.length; y++){

      if( (document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value.includes("modificarValor")) || (document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value === "postTeslaCommand|modificarAmperajeCarga") || (document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value === "Telegram|sendTelegram")){     
        jsonGuardado.Rule.actions[y].action = document.getElementById("selectBloquesAcciones"+jsonGuardado.Rule.actions[y].actionId).value+"|"+document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value+"|"+document.getElementById("valorAccion"+jsonGuardado.Rule.actions[y].actionId).value      
      }
      else if(document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value.includes("Email|sendEmail")){
        try{
          accionTemp = document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value.split("···")[0]
          emailTemp = document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value.split("···")[1]
        }
        catch(error){
          accionTemp = "Email|sendEmail"
          emailTemp = generalCommonJS.obtenerEmailUsuario()
        }

        jsonGuardado.Rule.actions[y].action = document.getElementById("selectBloquesAcciones"+jsonGuardado.Rule.actions[y].actionId).value+"|"+accionTemp+"|"+emailTemp+"###"+document.getElementById("valorAccion"+jsonGuardado.Rule.actions[y].actionId).value
      }
      else{
        jsonGuardado.Rule.actions[y].action = document.getElementById("selectBloquesAcciones"+jsonGuardado.Rule.actions[y].actionId).value+"|"+document.getElementById("selectAcciones"+jsonGuardado.Rule.actions[y].actionId).value
      }

      jsonGuardado.Rule.actions[y].frequency = document.getElementById("selectFrecuenciaNotificacion"+jsonGuardado.Rule.actions[y].actionId).value

    }

    return jsonGuardado

  }

  function guardar(){

    if(validacionCamposCorrecta()){
      params.guardarRegla(generarJSONGuardado(), "Informativo")
    }    

  }

  function mensajeConfimacionEliminarInstalacion(){
    initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","BORRADO DE REGLA", "¿Estás seguro de que quieres la regla "+params.rule.Rule.name+" ?", borradoRegla, initialConfigCommonJS.cerrarMensajeBorrado)          	
  }

  function borradoRegla(){
    rulesCommonJS.borrarRegla(params,params.volverAListadoReglas, ReactGA)
  }

  function mostrarEjemploRegla(){

    document.getElementById("divEjemploRegla").className = document.getElementById("divEjemploRegla").className.replaceAll(" hidden", "")

    var textoEjemplo = '<label class="link inline-link">Ejemplo:</label> "<strong>Cuando</strong> la temperatura exterior sea menor de 18ºC, <strong>quiero que</strong> me envíes un email."'

    if(JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.MainElectricConnectionSensorsInInstallation === "false"){
      textoEjemplo = '<label class="link inline-link">Ejemplo:</label> "<strong>Cuando</strong> la temperatura exterior sea menor de 18ºC, <strong>quiero que</strong> me envíes un email."'       
      if(JSON.parse(localStorage.getItem("lastSmartDevicesStatus")).length > 0){
        textoEjemplo = '<label class="link inline-link">Ejemplo:</label> "<strong>Cuando</strong> la temperatura exterior sea mayor de 30º, <strong>quiero que</strong> bajes las persianas."'       
      }
    }    
    else{
      textoEjemplo = '<label class="link inline-link">Ejemplo:</label> "<strong>Cuando</strong> la energía comprada (consumida) del mes sea mayor de 15€, <strong>quiero que</strong> me envíes un email."'       
      if(Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).FVData).length > 0){
        textoEjemplo = '<label class="link inline-link">Ejemplo:</label> "<strong>Cuando</strong> la energía fotovoltáica perdida / desaprovechada sea mayor que 1.400 Wh, <strong>quiero que</strong> enciendas el calentador del agua."'       
      }
    }

    document.getElementById("reglaEjemplo").innerHTML = textoEjemplo
    
  }

  function visibilidadModalFiltradoDatos(accion){

    if(accion === "abrir"){
      document.getElementById("detalleLateralFiltradoElementosReglas").className = document.getElementById("detalleLateralFiltradoElementosReglas").className.replaceAll(" hidden", "")      
    }
    else{
      document.getElementById("detalleLateralFiltradoElementosReglas").className = document.getElementById("detalleLateralFiltradoElementosReglas").className.replaceAll(" hidden", "") + " hidden"      
    }

  }

  return (    
    <>      

      <div className="rules-content vertical">
        
        <div id="divEjemploRegla" className="message info hidden">
          <p id="reglaEjemplo"></p>
        </div>

        <div className="rule-step vertical" id="DatosGenerales">

          <h1 id="tituloInformacionBasicaAcordeon" className="headline-04">Nombre y estado</h1>

          <section id="sectionInfoBasicaRegla" className="bubble rule expanded">

            <button className="link expandable" onClick={ () => mostrarOcultarBloqueResumen("sectionInfoBasicaRegla")}>
              <span className="material-icon fold show-expanded">unfold_more</span>
              <span className="material-icon fold show-collapsed">unfold_less</span>
            </button>

            <fieldset className="detail">              

              <fieldset className="text">
                <label htmlFor="name">Nombre de la regla</label>
                <input type="text" id="nombreRegla" onBlur={ () => mostrarOcultarBloqueResumen("sectionInfoBasicaRegla")}/>
              </fieldset>

              <fieldset className="check toggle green">
                <li className="check multiple toggle devices full-bleed">
                  <input type="checkbox" id="estadoRegla" name="estadoRegla" defaultChecked/>
                  <label className="icon-wrapper" htmlFor="estadoRegla">Deja marcada esta opción si quieres que la regla quede activa cuando le des a "Guardar"</label>
                </li>
              </fieldset>
              
            </fieldset>

            <div className="summary horizontal gap-03 vertical-center">                  
              <figure id="figureEstadoActivacionResumenRegla" className="avatar size-m cyan"><span id="spanEstadoActivacionResumenRegla" className="material-icon"></span></figure>
              <h1 id="resumenInfoGeneralRegla"> </h1>
            </div>

          </section>
        </div>

        <div className="rule-step vertical" id="Condiciones" >

          <h1 id="tituloCondicionesAcordeon" className="headline-04">¿<strong>Cuándo</strong> quieres que pase?</h1>
          
          <ConditionsList 
            objRule={params.rule} 
            objDatosDashboard={params.objDatosDashboard} 
            objDatosDispositivos={params.objDatosDispositivos}             
            eliminarCondicion={eliminarCondicion}
            mostrarOcultarBloqueResumen={mostrarOcultarBloqueResumen}
            visibilidadModalFiltradoDatos={visibilidadModalFiltradoDatos}
            setObjRuleElementSelector={params.setObjRuleElementSelector}/>

          <div className="actions center">
            <button className="link" type="button" onClick={ () => añadirCondicion()}><span className="material-icon">add_circle</span>Añadir condición</button>
          </div>

        </div>

        <div className="rule-step vertical" id="Acciones">

          <h1 id="tituloAccionesAcordeon" className="headline-04">¿<strong>Qué</strong> quieres que pase?</h1>

          <ActionList
            objRule={params.rule} 
            objDatosDashboard={params.objDatosDashboard} 
            objDatosDispositivos={params.objDatosDispositivos} 
            eliminarAccion={eliminarAccion}
            mostrarOcultarBloqueResumen={mostrarOcultarBloqueResumen}
            visibilidadModalFiltradoDatos={visibilidadModalFiltradoDatos}
            setObjRuleElementSelector={params.setObjRuleElementSelector}
            />

          <div className="actions center">
            <button className="link" type="button" onClick={ () => añadirAccion()}><span className="material-icon">add_circle</span>Añadir acción</button>
          </div>

        </div>

        <FormValidationError/>

        <ul className="actions">
          <button className="button primary" type="button" onClick={ () => guardar()}>Guardar</button>              
          
          { params.rule.RULE_ID !== "" ?
          <button id="botonEliminarRegla" className="button secondary delete" onClick={() => mensajeConfimacionEliminarInstalacion()}>Eliminar regla</button>
          : <></>
          }
          
        </ul>

      </div>



    </>
  )
}

export default RuleForm